import { useState } from "react";

export default function NewTask({onAdd})
{
    const [taskName,setTaskname] = useState('');
    function handleChange(event)
    {
        setTaskname(event.target.value)
    }

    function handleClick()
    {
       if( taskName.trim() === '')
         return 
       onAdd(taskName)
       setTaskname('');
    }
    return (
       <div className="flex items-center gap-4">
          <input 
          type="text" 
          className="w-64 px-2 py-1 rounded-sm bg-stone-200"
          onChange={handleChange}
          value={taskName}/>
          <button 
          className="text-stone-700 hover:text-stone-950"
          onClick={handleClick}
          >Add Task</button>
       </div>
    );
}